import React from "react";

const UserRoute = ({children}) => {
    return children;
};

export default UserRoute;